import * as React from 'react';

function SvgCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.93 23.93" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M22.33 5.99a11.74 11.74 0 011.62 6 11.72 11.72 0 01-1.61 6 11.94 11.94 0 01-4.39 4.34 11.74 11.74 0 01-6 1.66 11.74 11.74 0 01-6-1.61 11.94 11.94 0 01-4.34-4.39 11.72 11.72 0 01-1.61-6 11.74 11.74 0 011.61-6 11.94 11.94 0 014.34-4.38 11.74 11.74 0 016-1.62 11.74 11.74 0 016 1.61 11.94 11.94 0 014.38 4.39z" />
    </svg>
  );
}

const MemoSvgCircle = React.memo(SvgCircle);
export default MemoSvgCircle;
